export default "__VITE_ASSET__Dc1dCkh___"